<template>
  <div class="row price-profiles">
    <div class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">

          <!-- LOADING OVERLAY -->
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <!-- TOP BAR -->
          <div class="table-top" ref="tableTop" style="display: flex; justify-content: space-between;align-items: flex-start;gap: 10px;flex-wrap: wrap;flex-direction: column;">

            <!-- RIGHT: ADD BUTTON -->
            <div class="right-group" style="flex: 0 0 auto; margin-bottom: 20px; margin-top: 10px;">
              <button class="btn add" @click.prevent="goToAdd" :title="$t('general.add') + ' Price Profile'" style="font-size: 12px; padding: 4px 8px;">
                <img src="/static/img/icons/icon-plus-sm.png" /> {{ $t('general.add') }} Price Profile
              </button>
            </div>

          </div>

          <!-- TABLE -->
          <div class="data-table" style="margin-top: 20px;">
            <el-table :data="tableData" :empty-text="$t('gestiune.noData')" style="width: 100%;" @row-click="onRowClick">
              <el-table-column prop="id" label="Id" width="80"/>
              <el-table-column prop="name" label="Nume Profil"/>
              
              <el-table-column prop="locations" label="Locații Asignate">
                <template slot-scope="scope">
                  <div class="locations-scroll-horizontal">
                    <template v-if="scope.row.location_details && scope.row.location_details.length">
                      <span
                        v-for="loc in scope.row.location_details"
                        :key="loc.id"
                        class="location-item"
                      >
                        {{ loc.name }}
                      </span>
                    </template>
                    <span v-else class="location-item text-muted">
                      Nicio locație
                    </span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="filters" label="Filtre">
                <template slot-scope="scope">
                  <div class="locations-scroll-horizontal">
                    <span
                      v-for="group in scope.row.customers_groups"
                      :key="'g' + group.id"
                      class="location-item"
                    >
                      Grup: {{ group.name }}
                    </span>
                    <span
                      v-for="range in scope.row.delivery_ranges"
                      :key="'r' + range.id"
                      class="location-item"
                    >
                      Zonă: {{ range.name }} ({{ locationNameByToken(range.location_id) }})
                    </span>
                    <span
                      v-for="category in scope.row.top_categories"
                      :key="'c' + category.id"
                      class="location-item"
                    >
                      Categorie: {{ category.name }}
                    </span>
                    <span v-if="!hasFilters(scope.row)" class="location-item text-muted">
                      Doar locație
                    </span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column :label="$t('general.actions')" width="120">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                    <span class="arrow-box">&#9662;</span>
                    <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                      <el-dropdown-item @click.native.stop="goToEdit(scope.row)">
                        {{$t('general.edit')}}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native.stop="deleteProfile(scope.row)" divided>
                        <span style="color: #f56c6c;">{{$t('general.delete')}}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <!-- PAGINATION -->
            <el-pagination
              v-if="paginationDef.totalRecords > 0"
              layout="prev, pager, next"
              :total="paginationDef.totalRecords"
              :page-size="paginationDef.perPage"
              :current-page.sync="paginationDef.page"
              @current-change="handlePageChange"
              style="margin-top: 15px; text-align: right;"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  export default {
    data () {
      return {
        loading: true,
        paginationDef: {
          page: 1,
          perPage: 20,
          totalPages: null,
          totalRecords: 0
        },
        tableData: []
      }
    },
    created () {
      if (!this.guardPriceListsAccess()) {
        return
      }
      this.getPriceProfiles()
      this.$bus.$on('refresh', this.handleRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.paginationDef.page = 1
        this.getPriceProfiles()
      },
      getPriceProfiles () {
        this.loading = true
        var self = this
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          page: this.paginationDef.page,
          perPage: this.paginationDef.perPage
        }

        this.apiRequest('/price-profiles', 'GET', data, function (response) {
          if (response.status) {
            self.tableData = response.data || []
            
            // Set pagination data
            if (response.pagination) {
              self.paginationDef.page = response.pagination.page
              self.paginationDef.perPage = response.pagination.perPage
              self.paginationDef.totalPages = response.pagination.totalPages
              self.paginationDef.totalRecords = response.pagination.totalRecords
            }
          } else {
            self.tableData = []
            self.paginationDef.totalRecords = 0
          }
          self.loading = false
        })
      },

      // delivery_ranges.location_id este TOKEN-ul locației
      locationNameByToken (token) {
        const companyData = this.$session.get('selectedCompanyData') || {}
        const locations = companyData.locations_details || []
        const found = locations.find(loc => String(loc.token) === String(token))
        return found ? found.name : token
      },

      hasFilters (row) {
        return !!((row.customers_groups && row.customers_groups.length) ||
          (row.delivery_ranges && row.delivery_ranges.length) ||
          (row.top_categories && row.top_categories.length))
      },

      onRowClick (row, column, event) {
        if (event.target.closest('.el-dropdown')) {
          return
        }
        this.goToEdit(row)
      },

      goToAdd () {
        this.$router.push({
          name: 'Add Price Profile'
        })
      },

      goToEdit (row) {
        this.$router.push({
          name: 'Edit Price Profile',
          params: {
            id: row.id
          }
        })
      },

      handlePageChange (page) {
        this.paginationDef.page = page
        this.getPriceProfiles()
      },

      deleteProfile (row) {
        let self = this
        
        swal({
          title: 'Confirmare ștergere',
          text: `Ești sigur că vrei să ștergi profilul "${row.name}"?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes'),
          cancelButtonText: self.$t('general.no'),
          confirmButtonColor: '#f56c6c'
        }).then((result) => {
          if (result) {
            var data = {
              token: self.$session.get('token'),
              company_id: self.$session.get('selectedCompany')
            }
            
            self.apiRequest('/price-profiles/' + row.id, 'DELETE', data, function (response) {
              if (response.status) {
                self.trackAdminEvent('ADMIN_PRICE_LIST_DELETED', 'price_list', row.id, {
                  price_list_id: row.id,
                  name: row.name || null
                })
                swal({
                  type: 'success',
                  title: self.$t('validations.success'),
                  text: 'Profil șters cu succes',
                  timer: 2000,
                  showConfirmButton: false
                })
                
                // Refresh current page or go to previous if empty
                if (self.tableData.length === 1 && self.paginationDef.page > 1) {
                  self.paginationDef.page--
                }
                self.getPriceProfiles()
              } else {
                swal(
                  '',
                  response.message || self.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
.price-profiles .form-group {
  margin-bottom: 15px;
}
.tableInvoice .el-table .cell {
  height: auto;
  padding: 12px 0;
}
.locations-scroll-horizontal {
  max-width: 300px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}
.location-item {
  display: inline-block;
  margin-right: 8px;
  background-color: #f0f2f5;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}
.location-item.text-muted {
  background-color: transparent;
  color: #909399;
  font-style: italic;
}
.arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2;
}
.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important;
}
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/PriceProfile.vue